import TextField from "@mui/material/TextField";

import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";

import React, { useEffect, useState } from "react";

import { useSelector, useDispatch } from "react-redux";
import {
  Alert,
  Checkbox,
  FormControlLabel,
  Slide,
  Snackbar,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { updateProduct } from "../../feature/products/updateProductSlice";

// const Input = styled("input")({
//   display: "none",
// });

const UpdateProductForm = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    productDetails,
    isLoading,
    isSuccess,
    // isError,
    updateProductStatus,
    updateProductError,
    message,
  } = useSelector((state) => state.updateProducts);

  const { categories } = useSelector((state) => state.categories);

  console.log("productDetails", productDetails);

  // const [productName, setProductName] = useState(
  //   productDetails[0]?.product_name
  // );

  const [productInfo, setProductInfo] = useState({
    id: "",
    productCategory: "",
    productName: "",
    productBrand: "",
    productAmount: "",
    productDiscountPrice: "",
    product_discount_price: "",
    productDiscountPercentage: "",
    product_discount_percentage: "",
    productTag: "",
  });

  const [additionalInfo, setAdditionalInfo] = useState({
    productDescription: "",
    productBenefits: "",
    storageAndUsage: "",
    otherProductInfo: "",
    productType: "",
    productSlug: "",
    isWeightVariable: "",
  });

  const [open, setOpen] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    setProductInfo({
      id: productDetails[0]?.id,
      productCategory: productDetails[0]?.category_id,
      productName: productDetails[0]?.product_name,
      productBrand: productDetails[0]?.brand,
      productAmount: productDetails[0]?.product_amount,
      productDiscountPrice: productDetails[0]?.product_discount_price,
      productDiscountPercentage: productDetails[0]?.product_discount_percentage,
      productTag: productDetails[0]?.tag,
    });

    setAdditionalInfo({
      productDescription: productDetails[0]?.description,
      productBenefits: productDetails[0]?.benefits,
      storageAndUsage: productDetails[0]?.storage_and_usage,
      otherProductInfo: productDetails[0]?.other_product_info,
      productType: productDetails[0]?.product_type,
      productSlug: productDetails[0]?.product_slug,
      isWeightVariable: productDetails[0]?.is_weight_variable,
    });
  }, [productDetails]);

  //   const [productMultiImages, setProductMultiImages] = useState([]);
  //   const [selectedMultiImages, setSelectedMultiImages] = useState([]);
  //   const [selectedImages, setSelectedImages] = useState(null);

  //   const { productId } = useSelector((state) => state.addProducts);

  //   const { isLoading, isSuccess, isError, message } = useSelector(
  //     (state) => state.products
  //   );

  //   useEffect(() => {
  //     if (productId !== "" && productMultiImages.length !== 0) {
  //       return dispatch(
  //         uploadProductImages({ productId, productImages: productMultiImages })
  //       );
  //     }
  //     setProductMultiImages([]);
  //     setSelectedMultiImages([]);
  //   }, [productId, dispatch]);

  useEffect(() => {
    if (
      productInfo.productDiscountPrice !== "" &&
      productInfo.productAmount !== ""
    ) {
      let price = productInfo.productAmount;
      let discount = productInfo.productDiscountPrice;
      let discountedPrice = price - discount;

      let discountPercentage = (discountedPrice / price) * 100;

      if (discountPercentage < 0) {
        setError("Discount can not be more than Product Price");
        setProductInfo({
          ...productInfo,
          productDiscountPercentage: "",
        });
      } else {
        setError("");
        let exactDiscountPercent = Math.round(discountPercentage);
        setProductInfo({
          ...productInfo,
          productDiscountPercentage: exactDiscountPercent,
        });
      }
    } else {
      setError("");
      setProductInfo({
        ...productInfo,
        productDiscountPercentage: "",
      });
    }
  }, [
    productInfo.productAmount,
    productInfo.productDiscountPrice,
    productInfo.productDiscountPercentage,
  ]);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const productDetails = { ...productInfo, ...additionalInfo };

    dispatch(updateProduct(productDetails));
    // if (isSuccess && message !== "") {
    //   console.log("success response", message);
    //   setProductInfo({
    //     productCategory: "",
    //     productName: "",
    //     productBrand: "",
    //     productAmount: "",
    //     productDiscountPrice: "",
    //     product_discount_price: "",
    //     productDiscountPercentage: "",
    //     product_discount_percentage: "",
    //     productTag: "",
    //   });
    //   setAdditionalInfo({
    //     productDescription: "",
    //     productBenefits: "",
    //     storageAndUsage: "",
    //     otherProductInfo: "",
    //     productType: "",
    //     productSlug: "",
    //     isWeightVariable: "",
    //   });
    // } else {
    //   console.log("error response", message);
    // }
  };

  if (isLoading) return <h2>Loading...</h2>;

  return (
    <>
      {/* <form onSubmit={handleSubmit}> */}
      <Stack direction='column' spacing={2}>
        {error === "" ? null : <span style={{ color: "red" }}>{error}</span>}
        <TextField
          fullWidth
          name='state'
          required
          select
          SelectProps={{ native: true }}
          value={productInfo.productCategory}
          variant='outlined'
          onChange={(e) => {
            setProductInfo({
              ...productInfo,
              productCategory: e.target.value,
            });
          }}
        >
          <option value=''>Select Category</option>
          {categories?.map((category) => (
            <option key={category.id} value={category.id}>
              {category.category_name}
            </option>
          ))}
        </TextField>
        <TextField
          fullWidth
          label='Product Name'
          value={productInfo.productName}
          id='product_name'
          required
          onChange={(e) => {
            setProductInfo({
              ...productInfo,
              productName: e.target.value,
            });
          }}
        />
        <TextField
          fullWidth
          label='Product Brand/Vendor'
          value={productInfo.productBrand}
          id='product_brand'
          required
          onChange={(e) => {
            setProductInfo({
              ...productInfo,
              productBrand: e.target.value,
            });
          }}
        />
        <TextField
          fullWidth
          label='Product Price'
          value={productInfo.productAmount}
          id='product_amount'
          type='number'
          required
          onChange={(e) => {
            setProductInfo({
              ...productInfo,
              productAmount: e.target.value,
            });
          }}
        />
        <TextField
          fullWidth
          label='Product Discounted Price'
          value={productInfo.productDiscountPrice}
          id='product_discount_price'
          type='number'
          required
          onChange={(e) => {
            setProductInfo({
              ...productInfo,
              productDiscountPrice: e.target.value,
            });
          }}
        />

        <TextField
          fullWidth
          InputProps={{ readOnly: true }}
          label='Product Discount Percentage'
          type='number'
          value={productInfo.productDiscountPercentage}
          id='product_discount_price'
          required
        />
        <TextField
          fullWidth
          label='Product Tag'
          value={productInfo.productTag}
          id='product_tag'
          required
          onChange={(e) => {
            setProductInfo({
              ...productInfo,
              productTag: e.target.value,
            });
          }}
        />
        {/* <Box>
          <label htmlFor='upload-file'>Upload Product Image</label>
          <br />
          <Button variant='contained' component='label'>
            Choose File
            <Input
              accept='image/*'
              id='upload-file'
              required
              type='file'
              onChange={onSelectedFile}
              // hidden
            />
          </Button>
          <br />
          <Box>
            {selectedImages !== null && (
              <img src={selectedImages} alt='' height='200' />
            )}
          </Box>
        </Box> */}
        <TextField
          fullWidth
          multiline
          rows={4}
          label='Product Description'
          value={additionalInfo.productDescription}
          id='product_description'
          required
          onChange={(e) => {
            setAdditionalInfo({
              ...additionalInfo,
              productDescription: e.target.value,
            });
          }}
        />
        <TextField
          fullWidth
          multiline
          rows={4}
          label='Product Benefits '
          value={additionalInfo.productBenefits}
          id='product_benefits'
          required
          onChange={(e) => {
            setAdditionalInfo({
              ...additionalInfo,
              productBenefits: e.target.value,
            });
          }}
        />
        <TextField
          fullWidth
          multiline
          rows={4}
          label='Storage And Usage'
          value={additionalInfo.storageAndUsage}
          id='storage_and_usage'
          required
          onChange={(e) => {
            setAdditionalInfo({
              ...additionalInfo,
              storageAndUsage: e.target.value,
            });
          }}
        />
        <TextField
          fullWidth
          multiline
          rows={4}
          label='Other Product Info'
          value={additionalInfo.otherProductInfo}
          id='other_product_info'
          required
          onChange={(e) => {
            setAdditionalInfo({
              ...additionalInfo,
              otherProductInfo: e.target.value,
            });
          }}
        />
        <TextField
          fullWidth
          label='Product Type'
          value={additionalInfo.productType}
          id='product_type'
          required
          onChange={(e) => {
            setAdditionalInfo({
              ...additionalInfo,
              productType: e.target.value,
            });
          }}
        />
        <TextField
          fullWidth
          label='Product Slug'
          value={additionalInfo.productSlug}
          id='product_slug'
          required
          onChange={(e) => {
            setAdditionalInfo({
              ...additionalInfo,
              productSlug: e.target.value,
            });
          }}
        />
        <FormControlLabel
          control={
            <Checkbox
              color='info'
              checked={additionalInfo.isWeightVariable}
              onChange={(e) => {
                setAdditionalInfo({
                  ...additionalInfo,
                  isWeightVariable: e.target.checked,
                });
              }}
            />
          }
          label='Is Weight Variable'
        />
        {/* <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 5,
          }}
        >
          <Box alignSelf={"center"}>
            <label htmlFor='upload-file'>
              <Button variant='contained' component='span' color='error'>
                Upload Product Images
              </Button>
            </label>
            <Input
              accept='image/*'
              id='upload-file'
              multiple
              type='file'
              onChange={onSelectedFile}
            />
          </Box>

          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 5,
            }}
          >
            {selectedMultiImages &&
              selectedMultiImages.map((image, index) => {
                return (
                  <Box
                    key={image}
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <img
                      src={image}
                      alt=''
                      style={{
                        objectFit: "contain",
                      }}
                      height='150'
                      width='180'
                    />
                    <Button
                      variant='contained'
                      onClick={() =>
                        setSelectedMultiImages(
                          selectedMultiImages.filter((e) => e !== image)
                        )
                      }
                    >
                      <DeleteTwoToneIcon color='error' />
                    </Button>
                  </Box>
                );
              })}
          </Box>
        </Box> */}
      </Stack>
      <Stack
        alignItems={"center"}
        justifyContent={"center"}
        direction={"row"}
        spacing={2}
      >
        <Button variant='contained' color='error' onClick={handleSubmit}>
          Update
        </Button>
        <Button
          variant='contained'
          color='error'
          onClick={() => navigate("/products")}
        >
          Back
        </Button>
      </Stack>
      {/* </form> */}

      {updateProductStatus === "rejected" ? (
        <Snackbar
          open={open}
          autoHideDuration={4000}
          TransitionComponent={Slide}
          transitionDuration={{ enter: 1000, exit: 4000 }}
          TransitionProps={{ enter: true, exit: false }}
          onClose={handleClose}
        >
          <Alert severity='error'>{updateProductError}</Alert>
        </Snackbar>
      ) : null}
      {updateProductStatus === "success" ? (
        <Snackbar
          open={open}
          autoHideDuration={4000}
          TransitionComponent={Slide}
          transitionDuration={{ enter: 1000, exit: 4000 }}
          TransitionProps={{ enter: true, exit: false }}
          onClose={handleClose}
        >
          <Alert severity='error'> Product Updated... </Alert>
        </Snackbar>
      ) : null}

      {/* <Snackbar
        open={open}
        autoHideDuration={4000}
        TransitionComponent={Slide}
        transitionDuration={{ enter: 1000, exit: 4000 }}
        TransitionProps={{ enter: true, exit: false }}
        onClose={handleClose}
      >
        <Alert onClose={handleClose} severity='success' sx={{ width: "100%" }}>
          Your Category is Updated!
        </Alert>
      </Snackbar> */}
    </>
  );
};

export default UpdateProductForm;
